import { useQuery } from "@apollo/client";
import { SALON_REVIEW_STATS_QUERY } from "@/graphql/salon-reviews";
import { useSalonStore } from "@/lib/store/salon";

/**
 * Returns the count of Google reviews that are unreplied and not snoozed.
 * Used by the Customer Service nav badge.
 */
export function useUnrepliedReviewCount(): number {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data } = useQuery(SALON_REVIEW_STATS_QUERY, {
    variables: { salonId: salonId ?? "", input: { maxRating: 3 } },
    skip: !salonId,
    errorPolicy: "all",
    pollInterval: 60_000, // refresh badge every minute
  });

  return data?.salonReviewStats?.unrepliedCount ?? 0;
}
